import { useState } from "react";
import { faqs } from "@/mocks/content";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full px-4 md:px-8 py-14 md:py-20">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
        <div className="lg:col-span-1">
          <span className="text-xs md:text-sm text-accent-700 font-medium">常见问题</span>
          <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950 mt-1">
            关于看料91
          </h2>
          <p className="text-sm text-foreground-600 mt-4 leading-relaxed">
            这里整理了用户最常提出的几个问题，包括内容范围、更新频率与使用方式。如果还有疑问，欢迎通过联系页面留言。
          </p>
        </div>

        <div className="lg:col-span-2">
          <div className="bg-background-100 rounded-lg divide-y divide-background-200">
            {faqs.map((f, i) => {
              const isOpen = open === i;
              return (
                <div key={f.q}>
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : i)}
                    aria-expanded={isOpen}
                    className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-5 text-left cursor-pointer"
                  >
                    <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900">
                      {f.q}
                    </h3>
                    <span className="w-6 h-6 flex-shrink-0 flex items-center justify-center text-primary-600">
                      <i
                        className={isOpen ? "ri-subtract-line text-lg" : "ri-add-line text-lg"}
                      />
                    </span>
                  </button>
                  {isOpen && (
                    <p className="px-5 md:px-6 pb-5 text-sm text-foreground-600 leading-relaxed">
                      {f.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}